import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import ListenersMixin from "../../mixins/listeners.js";
import { slot } from "../../utils/slot.js";
export default Vue.extend({
  name: 'QPageContainer',
  mixins: [ListenersMixin],
  inject: {
    layout: {
      default: function _default() {
        console.error('QPageContainer needs to be child of QLayout');
      }
    }
  },
  provide: {
    pageContainer: true
  },
  computed: {
    style: function style() {
      var css = {};

      if (this.layout.header.space === true) {
        css.paddingTop = "".concat(this.layout.header.size, "px");
      }

      if (this.layout.right.space === true) {
        css["padding".concat(this.$q.lang.rtl === true ? 'Left' : 'Right')] = "".concat(this.layout.right.size, "px");
      }

      if (this.layout.footer.space === true) {
        css.paddingBottom = "".concat(this.layout.footer.size, "px");
      }

      if (this.layout.left.space === true) {
        css["padding".concat(this.$q.lang.rtl === true ? 'Right' : 'Left')] = "".concat(this.layout.left.size, "px");
      }

      return css;
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'q-page-container',
      style: this.style,
      on: _objectSpread({}, this.qListeners)
    }, slot(this, 'default'));
  }
});